import { Endpoints } from "../../../constants/endpoints";
import client from "../../client";
import { TRegisterUser, TRegisterUserBody } from "./types";

export const postRegisterUser = async (payload: TRegisterUserBody) => {
  const { data } = await client.post<TRegisterUserBody, TRegisterUser>(
    Endpoints.postRegisterUser,
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
